// extracted by mini-css-extract-plugin
module.exports = {"deadline":"Deadline_deadline__iCvOe"};